<div class="login-page">
  <mat-card>
    @if (hideForm) {
      <mat-card-title style="text-align:center;">Recuperar cuenta</mat-card-title>
    }
    <mat-card-content>
      @if (hideForm) {
        <div>
          <p>Introduce tu email:</p>
          <form [formGroup]="loginForm">
            <mat-form-field appearance="outline" class='formField'>
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" formControlName="loginEmail" required>
              <mat-error>El email es obligatorio</mat-error>
              <mat-error>Debe ser un email valido</mat-error>
              <mat-icon matSuffix color="primary" >email</mat-icon>
            </mat-form-field>
          </form>
          <button mat-raised-button color="primary" class="login-button" (click)="sendRecoverymail()"> Recuperar contraseña</button>
          <div class='actionBlock pointer' routerLink="/login">¡Ya tengo cuenta!</div>
        </div>
      }
      @if (!hideForm) {
        <div class='recoverMessageBlock'>
          <mat-icon color="primary" class='bigIcon'>mail_outline</mat-icon>
          <p class='callToaction'><b>¡Revise su correo!</b></p>
          <p>Revise su bandeja de entrada y haga clic en el enlace para cambiar su contraseña.</p>
          <button mat-raised-button color="primary" class="login-button" routerLink="/login"> Volver a iniciar sesión</button>
        </div>
      }
    </mat-card-content>
    @if (loading) {
      <div class='spinner'>
        <mat-spinner></mat-spinner>
      </div>
    }
  </mat-card>
</div>
